import React from 'react';

import LinkTab from 'retired/LinkTab';

const Tabs = () => (
  <>
    <LinkTab label="Accepted" path="/chapters/accepted" />
    <LinkTab label="Pending" path="/chapters/pending" />
    <LinkTab label="Rejected" path="/chapters/rejected" />
  </>
);

export default Tabs;
